import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import LTDemandTable from "./LTDemandTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_BULK_EDIT_PROCESSING_PLANT_DOWNLOAD_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_PROCESSING_PLANT_DOWNLOAD_API,
  LONG_DEMAND_GET_API,
  UPDATE_PROCESSING_PLANTS_BY_IDS,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_DEMAND_DOWNLOAD_API,
  LONG_BULK_EDIT_DEMAND_DOWNLOAD_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function LTDemand(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectFactory, setSelectFactory] = useState<any>("");
  const [selectBasepack, setSelectBasepack] = useState<any>("");
  const [selectCascade, setSelectCascade] = useState<any>("");
  const [selectLine, setSelectLine] = useState<any>("");
  const [productDescription, setProductDescription] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [factoryOptions, setFactoryOptions] = React.useState([]);
  const [basepackOptions, setBasepackOptions] = useState<any>([]);
  const [cascadeOptions, setCascadeOptions] = useState<any>([]);
  const [demandLocationDescriptionOption, setDemandLocationDescriptionOption] =
    useState<any>([]);
  const [productCodeOption, setProductCodeOption] = useState<any>([]);
  const [productDescriptionOption, setProductDescriptionOption] = useState<any>(
    [],
  );
  const [selectDemandLocationDescription, setSelectDemandLocationDescription] =
    useState<any>("");
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "demand_Location_Code", value: "" },
    { key: "demand_Location_Description", value: "" },
    { key: "product_Code", value: "" },
    { key: "product_Description", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const sortedFactoryNames = factoryOptions?.sort((a: any, b: any) =>
    a?.demand_Location_Code.localeCompare(b?.demand_Location_Code),
  );

  const sortedLineNames = lineOptions?.sort((a: any, b: any) =>
    a?.product_Code.localeCompare(b?.product_Code),
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };
  var line = 0;
  var base = 0;
  var time = 0;
  var fact = 0;
  var cascade = 0;
  var processing = 0;

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  /**Redux state */
  // const selectedUsecaseeId = useSelector(
  //   (state: any) => state.InputDataReducers.selectedUsecaseId,
  // );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>("tblScenario_Demand_LT");

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_Demand_LT_Module2");
      getfiltersApi("tblScenario_Demand_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_Demand_LT_Module3");
      getfiltersApi("tblScenario_Demand_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_Demand_LT_Module4");
      getfiltersApi("tblScenario_Demand_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_Demand_LT_Module5");
      getfiltersApi("tblScenario_Demand_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_Demand_LT_Module6");
      getfiltersApi("tblScenario_Demand_LT_Module6");
    } else {
      setTableName("tblScenario_Demand_LT");
      getfiltersApi("tblScenario_Demand_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const handleChangeSelectFactory = (event: any) => {
    setSelectBasepack("");
    setSelectDemandLocationDescription("");
    setSelectCascade("");
    // setSelectLine("");
    setProductDescription("");
    // setSelectTimePeriod("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    // filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectFactory(value);
    filterRequest[0].value = value;
    callTableGridApi();
    fact = 1;
    line = 0;
    base = 0;
    time = 0;
    cascade = 0;
    processing = 0;
  };

  const handleChangeSelectCascade = (event: any) => {
    setSelectBasepack("");
    setSelectDemandLocationDescription("");
    setSelectLine("");
    // setSelectTimePeriod("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    // filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectCascade(value);
    filterRequest[1].value = value;
    callTableGridApi();
    fact = 1;
    line = 0;
    base = 0;
    time = 0;
    cascade = 1;
    processing = 0;
  };

  const handleChangeDemandLocationDescription = (event: any) => {
    setSelectBasepack("");
    // setSelectLine("");
    setProductDescription("");
    // setSelectTimePeriod("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectDemandLocationDescription(value);
    filterRequest[1].value = value;
    callTableGridApi();
    fact = 1;
    line = 0;
    base = 0;
    time = 0;
    cascade = 1;
    processing = 1;
  };

  const handleChangeSelectLine = (event: any) => {
    setSelectBasepack("");
    // setSelectTimePeriod("");
    filterRequest[4].value = "";
    // filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setSelectLine(value);
    filterRequest[2].value = value;
    callTableGridApi();
    fact = 1;
    line = 1;
    base = 0;
    time = 0;
    cascade = 1;
    processing = 1;
  };

  const handleChangeSelectBasepack = (event: any) => {
    // setSelectTimePeriod("");
    const {
      target: { value },
    } = event;
    setSelectBasepack(value);
    setProductDescription(value);
    filterRequest[3].value = value;
    callTableGridApi();
    fact = 1;
    line = 1;
    base = 1;
    time = 0;
    cascade = 1;
    processing = 1;
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    filterRequest[4].value = value;
    callTableGridApi();
    fact = 1;
    line = 1;
    base = 1;
    time = 1;
    cascade = 1;
    processing = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        demand_Location_Code: "",
        demand_Location_Description: "",
        product_Code: "",
        product_Description: "",
        time_Period: "",
        demand_Vol: 0,
        sales_price: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_DEMAND_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };
  useEffect(() => {
    callTableGridApi();
    // getfiltersApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);

  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      time_period: timePeriodValues,
      table: tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    console.log(requestParam, "params");

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_DEMAND_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);

          setRows(response.data);
          if (cascade === 0) {
            setCascadeOptions(loadVendorOptions(response.data));
          }
          if (processing === 0) {
            setDemandLocationDescriptionOption(
              loadDemandLocationDescriptionOption(response.data),
            );
          }
          if (fact === 0) {
            setFactoryOptions(loadFactoryOptions(response.data));
          }
          if (line === 0) {
            setProductCodeOption(loadProductCodeOptions(response.data));
          }
          if (base === 0) {
            setProductDescriptionOption(
              loadProductDescriptionOptions(response.data),
            );
          }
          if (time === 0) {
            setTimePeriodOptions(loadTimePeriodOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  const loadFactoryOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.demand_Location_Code === item.demand_Location_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({
          id: item.id,
          demand_Location_Code: item.demand_Location_Code,
        });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadVendorOptions = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return obj.demand_Location_Code === item.demand_Location_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({
          id: item.id,
          demand_Location_Code: item.demand_Location_Code,
        });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadDemandLocationDescriptionOption = (data: any) => {
    const factoryOptions: any = [];
    data.map((item: any) => {
      const filteredItem = factoryOptions.find((obj: any) => {
        return (
          obj.demand_Location_Description === item.demand_Location_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        factoryOptions.push({
          id: item.id,
          demand_Location_Description: item.demand_Location_Description,
        });
      }
    });
    return factoryOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadProductDescriptionOptions = (data: any) => {
    console.log(data, "basepack");
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.product_Description === item.product_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({
          id: item.id,
          product_Description: item.product_Description,
        });
      }
    });
    return basePackOptions;
  };

  const loadTimePeriodOptions = (data: any) => {
    console.log(data, "basepack");
    const basePackOptions: any = [];
    data.map((item: any) => {
      const filteredItem = basePackOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        basePackOptions.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return basePackOptions;
  };

  const loadProductCodeOptions = (data: any) => {
    const lineOptions: any = [];
    data.map((item: any) => {
      const filteredItem = lineOptions.find((obj: any) => {
        return obj.product_Code === item.product_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        lineOptions.push({ id: item.id, product_Code: item.product_Code });
      }
    });
    return lineOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");

    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      time_period: timePeriodValues,
      pagesize: 100,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_DEMAND_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);

          setRows(response.data);
          setFactoryOptions(loadFactoryOptions(response.data));
          setProductDescriptionOption(
            loadProductDescriptionOptions(response.data),
          );
          setTimePeriodOptions(loadTimePeriodOptions(response.data));
          setDemandLocationDescriptionOption(
            loadDemandLocationDescriptionOption(response.data),
          );
          setCascadeOptions(loadVendorOptions(response.data));
          setProductCodeOption(loadProductCodeOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleRestoreClicked = (e: any) => {
    setSelectFactory("");
    setSelectBasepack("");
    setSelectDemandLocationDescription("");
    setSelectCascade("");
    setSelectLine("");
    setSelectTimePeriod("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    // filterRequest[5].value = "";
    callTableGridApi(tableName);
    fact = 0;
    line = 0;
    base = 0;
    time = 0;
    cascade = 0;
    processing = 0;
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "demand_Location_Code",
      "demand_Location_Description",
      "product_Code",
      "product_Description",
      "time_Period",
      "demand_Vol",
      "sales_price",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });

    console.log(transformedRows, "transformedRows");
    const urls = API_BASE_URL + LONG_BULK_EDIT_DEMAND_DOWNLOAD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          setEditedValue([]);
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited demand table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Demand"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>Demand</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Processing Plant Code</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectFactory}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectFactory}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Demand Location Code</em>
                  </MenuItem>
                  {sortedFactoryNames?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.demand_Location_Code}>
                        {d.demand_Location_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>SFG Code</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLine}
                  placeholder="Select Line"
                  onChange={handleChangeSelectLine}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Product Code</em>
                  </MenuItem>
                  {productCodeOption?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.product_Code}>
                        {d.product_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Time Period</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectTimePeriod: any) => selectTimePeriod}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <LTDemandTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default LTDemand;
